/* VOID — storefront behaviour.
   Small and framework-free. Everything here is an enhancement: with JavaScript
   off the page still renders, reads and sells, because every buy control is a
   real form, the accordions are native <details>, and the film button falls
   back to its poster. */

(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  var hasIO = "IntersectionObserver" in window;

  /* -------------------------------------------------------------------------
     1. Header: transparent over the homepage hero, solid once scrolled.
     On other pages the layout's .no-hero class makes it solid already.
     ------------------------------------------------------------------------- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var ticking = false;
    var updateHeader = function () {
      header.setAttribute("data-solid", window.scrollY > 40 ? "true" : "false");
      ticking = false;
    };
    updateHeader();
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateHeader);
        }
      },
      { passive: true }
    );
  }

  /* -------------------------------------------------------------------------
     2. Colour zones.
     While a [data-zone-name] section crosses the viewport's centre band, its
     name is written to <html> and the fixed .backdrop picks up the colour.
     Centre band rather than a visibility ratio: these sections are taller than
     the viewport, so a ratio would trip while the previous section still filled
     the screen and change colour under content meant to stay black.
     ------------------------------------------------------------------------- */
  var zones = document.querySelectorAll("[data-zone-name]");
  if (zones.length && hasIO) {
    var root = document.documentElement;
    var zoneObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var name = entry.target.getAttribute("data-zone-name");
          if (entry.isIntersecting) {
            root.setAttribute("data-zone", name);
          } else if (root.getAttribute("data-zone") === name) {
            root.setAttribute("data-zone", "void");
          }
        });
      },
      { threshold: 0, rootMargin: "-45% 0px -45% 0px" }
    );
    Array.prototype.forEach.call(zones, function (el) {
      zoneObserver.observe(el);
    });
  }

  /* -------------------------------------------------------------------------
     3. Reveals, once, on the scent sequence only.
     ------------------------------------------------------------------------- */
  var reveals = document.querySelectorAll(".reveal");
  if (reveals.length) {
    if (reduced.matches || !hasIO) {
      Array.prototype.forEach.call(reveals, function (el) {
        el.setAttribute("data-shown", "true");
      });
    } else {
      var revealObserver = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute("data-shown", "true");
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );
      Array.prototype.forEach.call(reveals, function (el) {
        revealObserver.observe(el);
      });
    }
  }

  /* -------------------------------------------------------------------------
     4. Sticky buy bar (phones; hidden by CSS from 900px up).
     Shown only when no other buy control is on screen: not while the product
     module or the closing block is visible, and not over the hero. While
     hidden it is also inert, so keyboard users cannot tab into it.
     ------------------------------------------------------------------------- */
  var bar = document.querySelector("[data-buybar]");
  var anchors = document.querySelectorAll("[data-product-module], [data-closing]");
  if (bar && hasIO && anchors.length) {
    var onScreen = new Set();
    var setBar = function () {
      var show = onScreen.size === 0 && window.scrollY > window.innerHeight * 0.8;
      bar.setAttribute("data-visible", show ? "true" : "false");
      bar.setAttribute("aria-hidden", show ? "false" : "true");
      if (show) bar.removeAttribute("inert");
      else bar.setAttribute("inert", "");
    };
    var barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) onScreen.add(entry.target);
        else onScreen.delete(entry.target);
      });
      setBar();
    });
    Array.prototype.forEach.call(anchors, function (el) {
      barObserver.observe(el);
    });
    window.addEventListener("scroll", setBar, { passive: true });
    setBar();
  }

  /* -------------------------------------------------------------------------
     5. The full film, gated behind a click. It opens on near-silence and a
     sub-bass drone; arriving unannounced on a phone it would be an ambush.
     ------------------------------------------------------------------------- */
  var filmButton = document.querySelector("[data-film-open]");
  if (filmButton) {
    filmButton.addEventListener("click", function () {
      var frame = filmButton.parentNode;
      var video = document.createElement("video");
      video.className = "film__video";
      video.controls = true;
      video.playsInline = true;
      video.preload = "auto";
      video.poster = filmButton.getAttribute("data-film-poster") || "";
      video.src = filmButton.getAttribute("data-film-src");
      frame.replaceChild(video, filmButton);
      video.focus();
      // Sound is allowed here because it is the direct result of this click.
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });
  }
})();
